import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import DialogPrice from "components/Configuration/Model/DialogPrice";
import DialogDistance from "components/Configuration/Model/DialogDistance";
import DialogChange from "components/Configuration/Model/DialogExpiry";
import Configuration from "components/Configuration/Configuration";
import { ConfigurationApi } from "stores/Configuration/ConfigurationApi";
import DialogGift from "components/Configuration/Model/DialogGift";

class ConfigurationContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      open: false,
      openprice: false,
      opendistance: false,
      openGift: false,
      convenienceId: "",
      convenience: "",
      referal_amount: "",
      referalId: "",
      loyality_point: "",
      loyalityId: "",
      gift_voucher_amount: "",
      giftId: "",
    };
  }

  componentDidMount() {
    this.props.getConfigurationTableAction();
  }

  onChangeConvenience = (name, value) => {
    if (name == "convenience") {
      this.setState({ convenience: value });
    }
    if (name == "referal_amount") {
      this.setState({ referal_amount: value });
    }
    if (name == "loyality_point") {
      this.setState({ loyality_point: value });
    }
    if (name == "gift_voucher_amount") {
      this.setState({ gift_voucher_amount: value });
    }
  };

  updateonConvenience = async () => {
    let convenience = this.state.convenience;
    let id = this.state.convenienceId;
    if (convenience) {
      await ConfigurationApi.UpdateConfigurationCancelApi({
        id: id,
        convenience: convenience,
      });
      await this.props.getConfigurationTableAction();
      this.setState({ open: false });
    } else {
    }
    return "empty";
  };

  updateonReferalAmount = async () => {
    let referal_amount = this.state.referal_amount;
    let id = this.state.referalId;
    if (referal_amount) {
      await ConfigurationApi.UpdateConfigurationCancelApi({
        id: id,
        referal_amount: referal_amount,
      });
      await this.props.getConfigurationTableAction();
      this.closeprice();
    }
  };

  updateonloyalityAmount = async () => {
    let loyality_point = this.state.loyality_point;
    let id = this.state.loyalityId;
    if (loyality_point) {
      await ConfigurationApi.UpdateConfigurationCancelApi({
        id: id,
        loyality_point: loyality_point,
      });
      await this.props.getConfigurationTableAction();
      this.handleDistanceClose();
    }
  };

  updateonGift = async () => {
    let gift_voucher_amount = this.state.gift_voucher_amount;
    let id = this.state.giftId;
    if (gift_voucher_amount) {
      await ConfigurationApi.UpdateConfigurationCancelApi({
        id: id,
        gift_voucher_amount: gift_voucher_amount,
      });
      await this.props.getConfigurationTableAction();
      this.closeGift();
    }
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  handleClickOpen = (id, convenience) => {
    this.setState({ open: true, convenience: convenience, convenienceId: id });
  };
  handleClickOpenReferal = (id, referal_amount) => {
    this.setState({
      openprice: true,
      referal_amount: referal_amount,
      referalId: id,
    });
  };

  closeprice = () => {
    this.setState({ openprice: false });
  };
  handleloyalityClickOpen = (id, loyality_point) => {
    this.setState({
      opendistance: true,
      loyality_point: loyality_point,
      loyalityId: id,
    });
  };

  handleDistanceClose = async () => {
    this.setState({ opendistance: false });
  };

  handleClickOpenGift = (id, gift_voucher_amount) => {
    this.setState({
      openGift: true,
      gift_voucher_amount: gift_voucher_amount,
      giftId: id,
    });
  };

  closeGift = () => {
    this.setState({ openGift: false });
  };

  render() {
    const gobleconfig = this.props?.ConfigurationTableList?.result
      ? this.props?.ConfigurationTableList?.result
      : [];


    return (
      <Grid container>
        <Stack p={0.5} mt={2}></Stack>

        <Grid item xs={12}>
          <Paper sx={{ p: 3, mt: 1 }}>
            <Configuration
              data={gobleconfig}
              handlePriceClickOpen={(val1, val2) => {
                this.handleClickOpenReferal(val1, val2);
              }}
              handleDistanceClickOpen={(val1, val2) => {
                this.handleloyalityClickOpen(val1, val2);
              }}
              handleClickOpen={(val1, val2) => {
                this.handleClickOpen(val1, val2);
              }}
              handleClickOpenGift={(val1, val2) => {
                this.handleClickOpenGift(val1, val2);
              }}
            />
          </Paper>
        </Grid>
        <DialogChange
          convenience={this.state.convenience}
          onChangeConvenience={this.onChangeConvenience}
          updateonConvenience={this.updateonConvenience}
          handleClose={this.handleClose}
          open={this.state.open}
        />
        <DialogPrice
          closeprice={this.closeprice}
          onChangeAddReferal={this.onChangeConvenience}
          openprice={this.state.openprice}
          referal_amount={this.state.referal_amount}
          updateonReferalAmount={this.updateonReferalAmount}
        />
        <DialogDistance
          onChangeloyality={this.onChangeConvenience}
          handleDistanceClose={this.handleDistanceClose}
          open={this.state.opendistance}
          loyality_point={this.state.loyality_point}
          updateAdvanceCharge={this.updateonloyalityAmount}
        />

        <DialogGift
          onChangeGift={this.onChangeConvenience}
          open={this.state.openGift}
          closeGift={this.closeGift}
          gift_voucher_amount={this.state.gift_voucher_amount}
          updateonGift={this.updateonGift}
        />
      </Grid>
    );
  }
}

export default ConfigurationContainer;
